/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  SigninMutationRequest,
  SigninMutationResponse,
  Signin401,
  Signin404,
} from "../types/Signin.ts"
import {
  signinMutationResponseSchema,
  signinMutationRequestSchema,
} from "../zod/signinSchema.ts"

function getSigninUrl() {
  const res = { method: "POST", url: `/auth/token` as const }
  return res
}

/**
 * @description Sign in
 * @summary Verify identity and obtain access tokens
 * {@link /auth/token}
 */
export async function signin(
  data: SigninMutationRequest,
  config: Partial<RequestConfig<SigninMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = signinMutationRequestSchema.parse(data)

  const res = await request<
    SigninMutationResponse,
    ResponseErrorConfig<Signin401 | Signin404>,
    SigninMutationRequest
  >({
    method: "POST",
    url: getSigninUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return signinMutationResponseSchema.parse(res.data)
}
